import { useContext } from 'react';
import { ISortSelectors, ISortState } from 'src/@complaints/interfaces';
import { actionTypes } from 'src/@complaints/actionTypes';
import { ComplaintsStateContext } from 'src/@complaints/providers/ComplaintsStateProvider';
import { useSelectors } from 'src/utils/storeHelpers';

export const useSortSelectors: () => ISortSelectors = () => {
  const state: any = useContext(ComplaintsStateContext);
  const dataState: ISortState = state.sort;

  return useSelectors(dataState, (state: ISortState) => ({
    getIconProps: sortName => {
      if (sortName === 'id' && state.sortArray.length > 1) {
        // do not show icon for time when it is implicit
        return false;
      }
      return findSortObject(state, sortName);
    },
    getSortString: () => {
      const sortArray = state.sortArray;
      const sortArrayLength = sortArray.length;
      let sortString = '';
      if (sortArrayLength) {
        for (let i = sortArrayLength; i--; ) {
          sortString = `${sortString} {field:"${sortArray[i].field}", direction:${
            sortArray[i].direction
          }} ${i ? ',' : ''}  `;
        }
      }
      return `sort: [${sortString}]`;
    },
  }));
};

const initSortArray: any = {
  field: 'time',
  direction: 'ASC',
};

export const sortInitialState: ISortState = {
  sortArray: [Object.assign({}, initSortArray)],
};

const findSortObject = (state, sortName) => {
  return state.sortArray.find(sortString => sortString.field && sortString.field === sortName);
};

export const sortReducer = (state: ISortState, action: any) => {
  switch (action.type) {
    case actionTypes.SORT_TABLE:
      const sortName = action.data;
      const sortObject = findSortObject(state, sortName);
      if (sortObject) {
        const newSortArray: any = state.sortArray.map(item => {
          if (item.field === sortName) {
            return Object.assign({}, item, {
              direction: item.direction === 'ASC' ? 'DESC' : 'ASC',
            });
          }
          return item;
        });
        return Object.assign({}, state, {
          sortArray: newSortArray,
        });
      } else {
        const newSortArray: any = [];

        newSortArray.push({ field: action.data, direction: 'ASC' });

        return Object.assign({}, state, {
          sortArray: newSortArray,
        });
      }

    default:
      return state;
  }
};
